import { render, staticRenderFns } from "./OnboardingTour.vue?vue&type=template&id=4bcf70c3&scoped=true&"
import script from "./OnboardingTour.vue?vue&type=script&lang=js&"
export * from "./OnboardingTour.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTour.vue?vue&type=style&index=0&id=4bcf70c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcf70c3",
  null
  
)

export default component.exports